<template>
  <div class="bg-[#23242A] text-white h-screen appheader overflow-y-auto p-3">
    <div class="p-3 flex content-main gap-5">
      
      <div class="custom-full">
        <Nav/>
        <div class="bg-[#2B2C32] rounded-lg px-8 mt-1 pt-1 pb-5">
          
          <div class="flex justify-between mt-5 h-[40px]">
            <h2 class="text-[24px] font-semibold text-white">Scanners</h2>
          </div>

          <div class="self-stretch py-2 inline-flex flex-col justify-start items-start gap-2">
            <div class="inline-flex justify-start items-start gap-4">
              <div class="justify-center text-white text-base font-normal font-['Roboto'] leading-5">Require verification</div>
              <label class="flex items-center">
                <input type="checkbox" v-model="form.enableScannerVerification.value" @change="updateScanner()" class="hidden peer">
                <div :class="'relative toggle-bg  border-2  h-6 w-11 rounded-full cursor-pointer ' + (form.enableScannerVerification.value ? 'bg-theme-green border-theme-green' : 'bg-[#F53333] border-[#F53333]')"></div>
                <span class="ml-2 text-white text-sm font-medium uppercase" :class="form.enableScannerVerification.value ? 'text-theme-green' : 'text-[#F53333]'">{{form.enableScannerVerification.value ? 'On' : 'Off'}}</span>
              </label>
            </div>
            <div class="justify-center text-white text-sm font-normal font-['Roboto'] leading-4">Default is off. If toggled on, the scanning flow changes to REQUIRE a scanned product before orders are completed.</div>
          
            <div v-if="form?.enableScannerVerification?.value" class="mt-10">
              <div class="justify-center text-white text-base font-normal font-['Roboto'] leading-5">Select products to exempt from forced scan verification</div>
              <div class="flex items-center w-[320px] mt-2">
                <span class="placeholder-white block bg-theme-modal_inner_bg pl-3 w-full focus:outline-0 text-sm text-theme-white border-none">{{selectedCatIds.length}} category, {{ selectedPids.length }} item{{ selectedPids.length > 1  ? 's' : '' }} selected</span>
                <button @click.prevent="showCategoryWithProductModal()" class="bg-white text-[#2BA66B] px-4 py-2 border-0 rounded cursor-pointer text-sm font-medium tracking-widest hover:bg-theme-green hover:text-white" for="">SELECT</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <CategoryWithProductModal v-if="categoryWithproductObj.active" title="Exempt Items" :closeClick="closeCategoryWithProductModal" :actionClick="setCategoriesWithProduct"/>
</template>


<script lang="ts">
import {defineComponent, ref} from "vue"
import { mapGetters, mapActions } from "vuex";
import Nav from '@/views/Location/Devices/Nav.vue';
import LocationPosStationApis from '@/controllers/LocationPosStationApis';
import BusinessCategoryApis from "@/controllers/BusinessCategoryApis";
import { useSnackbar } from "vue3-snackbar";
import Helpers from '@/helpers';
import CategoryWithProductModal from './CategoriesWithProductModal.vue';

  export default defineComponent({
  name: "LocationDevicesPos",
  components: {
   Nav,
   CategoryWithProductModal
  },

  setup() {
    const snackbar = useSnackbar();
    const form = ref({
      enableScannerVerification: {
        value: false,
      },
    })
    const categoryWithproductObj = ref({
      active: false,
    });
    const selectedPids = ref<any[]>([]);
    const selectedCatIds = ref<any[]>([]);

    return {
      snackbar,
      form,
      categoryWithproductObj,
      selectedPids,
      selectedCatIds
    };
  },

  computed: {
    ...mapGetters({
     vg_selectedLocation: 'location/selected',
     vg_activeBusiness: 'auth/activeBusiness',
    }),
  },

  mounted() {
    this.fetchScanner()
    this.getCategoryProductList()
    this.getExemptProductList()
  },

  watch: {
    'vg_selectedLocation'(val) {
      this.fetchScanner()
      this.getCategoryProductList()
      this.getExemptProductList()
    },
  },

 
  methods: {
    async fetchScanner(){
      let res = await LocationPosStationApis.locationScannerVerification();
      if(res.status===200){
        this.form.enableScannerVerification.value = res.data.payload.enableScannerVerification
      }else{
        this.form.enableScannerVerification.value = false
      }
    },
    async getCategoryProductList(){
      this.selectedCatIds = []
      let res = await BusinessCategoryApis.fetchCategoryProductTreeWithFilterBrandSearch(this.vg_activeBusiness.id);
      if(res.status == 200) {
        let catWithProducts = res?.data?.payload
        if(catWithProducts?.length>0){
          for(let i=0; i<catWithProducts.length; i++){
            // sub category
            if(catWithProducts[i]?.subCategories?.length>0){
              for(let j=0; j<catWithProducts[i]?.subCategories?.length; j++){
                if(catWithProducts[i]?.subCategories[j]?.exemptFromScanning) {
                  this.selectedCatIds.push(catWithProducts[i]?.subCategories[j]?.id)
                }
              }
            }

            // main category
            if(catWithProducts[i]?.exemptFromScanning) {
              this.selectedCatIds.push(catWithProducts[i]?.id)
            }
          }
        }
      }
    },
    async getExemptProductList(){
      let res = await LocationPosStationApis.exemptProductVerification();
      if(res.status===200){
        let products = res?.data?.payload
        if(products?.length>0){
          this.selectedPids = products.filter(each => each.exemptFromScanning).map(each => each.id)
        }else{
          this.selectedPids = []
        }
      }else{
        this.selectedPids = []
      }
    },
    async updateScanner(){
      this.va_spinner(true);
      let res = await LocationPosStationApis.updateLocationScannerVerification({
          enableScannerVerification: this.form.enableScannerVerification.value,
      });
      this.va_spinner(false);
        this.snackbar.add({
        type: 'info',
        text: res.status == 201 ? res.data.message : Helpers.catchErrorMessage(res.response.data),
        duration: 3000,
      })
      if(res.status == 201 ) {
        this.emitter.emit("refresh-location-pos-station-list", true);
      }
    },
    /**
     * Open product with category Model
     */
    showCategoryWithProductModal() {
      this.categoryWithproductObj.active = true;
    },
    /**
     * Close select category modal
     */
    closeCategoryWithProductModal() {
      this.categoryWithproductObj.active = false;
    },

    /**
     * Get data selected from category modal
     */
    async setCategoriesWithProduct(data) {

      this.closeCategoryWithProductModal();
      this.va_spinner(true);
      let res = await LocationPosStationApis.updateExemptProductVerification({
          productIds: data.pids,
          categoryIds: data.catids,
      });
      if(res.status===200){
        this.getCategoryProductList()
        this.getExemptProductList()
      }
      this.va_spinner(false);
        this.snackbar.add({
        type: 'info',
        text: res.status===200 ? res.data.message : Helpers.catchErrorMessage(res.response.data),
        duration: 3000,
      })
    },
    ...mapActions({
      va_spinner: 'spinner/setSpinner',
    })
  },
});

</script>

